class MultiStepsSection {
    constructor() {
        this.currentStep = 1;
        this.maxSteps = 5;
        this.selectedPath = {
            occasion: '',
            age: '',
            preference: '',
            collection: '',
        };

        this.init();
    }

    init() {
        // Initialize containers
        this.containers = {};
        for (let i = 1; i <= this.maxSteps; i++) {
            this.containers[i] = document.getElementById(`step-${i}`);
            if (i > 1) {
                this.containers[i].style.display = 'none';
            }
        }

        // Add click handlers for step 1 blocks
        const step1Blocks = document.querySelectorAll('#step-1 .content-block__block');
        step1Blocks.forEach((block) => {
            block.addEventListener('click', () => {
                this.selectedPath.occasion = block.querySelector('h3').textContent;
                this.navigateToStep(2);
            });
        });

        // Add click handlers for step 2 age blocks
        const step2Blocks = document.querySelectorAll('#step-2 .content-block__ages-block');
        step2Blocks.forEach((block) => {
            block.addEventListener('click', () => {
                this.selectedPath.age = block.querySelector('.age-block').textContent;
                this.navigateToStep(3);
            });
        });

        // Add click handlers for step 3 preference blocks
        const step3Blocks = document.querySelectorAll('#step-3 .overlay-text-image-block');
        step3Blocks.forEach((block) => {
            block.addEventListener('click', () => {
                this.selectedPath.preference = block.querySelector('h3').textContent;
                this.navigateToStep(4);
            });
        });

        // Add click handlers for step 4 collection blocks
        const step4Blocks = document.querySelectorAll('#step-4 .categories-block');
        step4Blocks.forEach((block) => {
            block.addEventListener('click', () => {
                // Get collection handle from data attribute
                const collectionHandle = block.getAttribute('data-collection');
                if (collectionHandle) {
                    console.log('Selected collection:', collectionHandle); // Debug log
                    this.selectedPath.collection = collectionHandle;
                    this.showCollectionProducts(collectionHandle);
                    this.navigateToStep(5);
                }
            });
        });

        // Add click handlers for back arrows
        const backArrows = document.querySelectorAll('.icon-arrow-left');
        backArrows.forEach((arrow) => {
            arrow.addEventListener('click', (e) => {
                e.stopPropagation();
                this.navigateBack();
            });
        });

        // Add hover effects
        this.addHoverEffects();

        // Debug: Log initial state of product blocks
        const productBlocks = document.querySelectorAll('.category-products');
        console.log('Initial product blocks:', productBlocks.length);
    }

    navigateToStep(step) {
        if (step < 1 || step > this.maxSteps) return;

        // Hide all steps
        Object.values(this.containers).forEach((container) => {
            container.style.display = 'none';
        });

        // Show new step
        this.containers[step].style.display = 'block';

        // Update current step
        this.currentStep = step;

        // Smooth scroll to top of section
        const section = document.querySelector('.bevy-multi-step');
        if (section) {
            section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    navigateBack() {
        if (this.currentStep > 1) {
            this.navigateToStep(this.currentStep - 1);
        }
    }

    showCollectionProducts(collectionHandle) {
        console.log('Showing products for collection:', collectionHandle); // Debug log

        // Hide all product blocks first
        const productBlocks = document.querySelectorAll('.category-products');
        productBlocks.forEach((block) => {
            block.style.display = 'none';
            block.classList.remove('active');
        });

        // Show selected collection's products
        const selectedBlock = document.querySelector(
            `.category-products[data-collection="${collectionHandle}"]`
        );
        if (selectedBlock) {
            console.log('Found product block:', selectedBlock); // Debug log
            selectedBlock.style.display = 'flex';
            selectedBlock.classList.add('active');
        } else {
            console.log('No product block found for collection:', collectionHandle); // Debug log
        }
    }

    addHoverEffects() {
        // Add hover effects for all clickable blocks
        const clickableBlocks = document.querySelectorAll(`
        .content-block__block,
        .content-block__ages-block,
        .overlay-text-image-block,
        .categories-block
      `);

        clickableBlocks.forEach((block) => {
            block.addEventListener('mouseenter', () => {
                block.style.transform = 'scale(1.02)';
                block.style.cursor = 'pointer';
            });

            block.addEventListener('mouseleave', () => {
                block.style.transform = 'scale(1)';
            });
        });
    }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    new MultiStepsSection();
});
